import Vue from "vue";
import Vuex from "vuex";
import historymoney from './historymoney'
import football from './football'
Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    historymoney,
    football
  }
});
